
import { lazy } from 'react';

export const LazyGoals = lazy(() => 
  import('@/pages/Goals').then(module => ({ default: module.Goals }))
);
